import { defineMessages } from "@/lib/i18n/messages";

export default defineMessages({
  es: {
    button: "Avísame",
    help: "Te enviaremos un correo para confirmar y te avisaremos el día antes del evento.",
    helpLoggedIn: "Te avisaremos por correo el día antes del evento.",
    tooSoon: "Este evento es muy pronto para avisarte.",
    tooSoonCalendar: "Este evento es muy pronto para avisarte. Agrégalo a tu calendario.",
    emailLabel: "Tu correo",
    emailPlaceholder: "tu@correo.com",
    submit: "Avisarme",
    cancel: "Cancelar",
    invalidEmail: "Revisa el correo: no parece válido.",
    pending: "Revisa tu correo y confirma el aviso. Si no lo ves, mira en spam.",
    confirmed: (day: string, hour: string) => `Listo: te avisaremos el ${day} a las ${hour}.`,
    already: "Ya tienes un aviso para este evento.",
    error: "No pudimos crear el aviso. Inténtalo de nuevo en un momento.",
    rateLimited: "Hiciste varios intentos seguidos. Espera un minuto y vuelve a intentarlo.",
  },
  en: {
    button: "Remind me",
    help: "We'll send you an email to confirm and remind you the day before the event.",
    helpLoggedIn: "We'll email you the day before the event.",
    tooSoon: "This event is too soon to remind you.",
    tooSoonCalendar: "This event is too soon to remind you. Add it to your calendar.",
    emailLabel: "Your email",
    emailPlaceholder: "you@email.com",
    submit: "Remind me",
    cancel: "Cancel",
    invalidEmail: "Check the email: it doesn't look valid.",
    pending: "Check your email and confirm the reminder. If you don't see it, look in spam.",
    confirmed: (day: string, hour: string) => `Done: we'll remind you on ${day} at ${hour}.`,
    already: "You already have a reminder for this event.",
    error: "We couldn't create the reminder. Please try again in a moment.",
    rateLimited: "Too many attempts in a row. Wait a minute and try again.",
  },
});
